<template>
  <div v-if="phase.active" :class="['home_bonus_box', isMidnightBonus ? 'midnight_bonus_box' : 'discount_bonus_box']">
    <div class="bonus_col">
      <img v-if="isMidnightBonus" :src="midnightBonusIconSrc">
      <img v-else :src="discountBonusIconSrc">
    </div>
    <div class="bonus_col">
      <h2> {{ isMidnightBonus ? getTranslations.home_points_multiplier_header : getTranslations.home_bundle_discount_header}} </h2>
      <div class="store_countdown">
        <p> {{ counter }} </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'bonus-box',
  mixins: [SkinMixin],
  props: {
    isMidnightBonus: {
      type: Boolean,
      required: true,
      default: true,
    },
    phase: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timer: 0,
      counter: 0,
    };
  },
  created() {
    this.$emit('isMobileDeviceMethod');
    this.initiateCountDownTimer();
  },
  methods: {
    initiateCountDownTimer() {
      const interval = 1000; // every 1 second
      let duration;
      // get time element
      // calculate difference between two times
      const eventTime = moment(this.phase.end);
      // loop to countdown every 1 second
      this.timer = setInterval(() => {
        // based on time set in user's computer time / OS
        const currentTime = moment(new Date());
        // get duration between two times
        duration = moment.duration(eventTime.diff(currentTime));
        // get updated duration
        duration = moment.duration(duration - interval, 'milliseconds');

        // if duration is >= 0
        if (currentTime.isAfter(eventTime)) {
          clearInterval(this.timer);
          // hide the countdown element
          this.counter = '';
          this.phase.active = false;
        } else {
          // otherwise, show the updated countdown
          this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
        }
      }, interval);
    },
  },
  computed: {
    midnightBonusIconSrc() {
      return this.$_skinImage({ fileName: 'daily_bonus/Bonus-Midnight-64px.png', skins: [100] });
    },
    discountBonusIconSrc() {
      return this.$_skinImage({ fileName: 'daily_bonus/Bonus-Discount-64px.png', skins: [100] });
    },
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/BonusBox.vue